import { render, staticRenderFns } from "./jdTabs.vue?vue&type=template&id=32845eba&scoped=true&"
import script from "./jdTabs.vue?vue&type=script&lang=js&"
export * from "./jdTabs.vue?vue&type=script&lang=js&"
import style0 from "./jdTabs.vue?vue&type=style&index=0&id=32845eba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32845eba",
  null
  
)

export default component.exports